
export const setUser = (user) => {
  localStorage.setItem('userDetails', JSON.stringify(user));
};

export const getUser = () => {
  const userDetails = localStorage.getItem('userDetails') ? JSON.parse(localStorage.getItem('userDetails')) : undefined;

  if (userDetails?.will_expire_at && new Date().getTime() < Number(userDetails.will_expire_at)) {
    return userDetails;
  }

  return { access_type_cd: 'c' };
};
